import baguetteBox from 'baguettebox.js';

export default function () {
	const imageGallery = document.getElementById('imageGallery');
	const pdpImage = document.getElementById('pdpImage');

	if (imageGallery != null) {
		baguetteBox.run('.c-gallery', {
			buttons: true,
			captions: false
		});
	};

	if (pdpImage != null) {
		baguetteBox.run('#pdpImage', {
			buttons: false,
			captions: false
		});
	};
}
